import { MouseEventHandler } from "react";
import { Course, day, defaultUrl } from "../../Scripts/misc";
import { Link } from "react-router-dom";

interface Props {
    course: Course;
    selectCourse: MouseEventHandler;
  }

function TeacherCourseCard({course, selectCourse}: Props) {
    return ( 
        <>
        
        <tr>
                    <td><img src={defaultUrl + course.image} className="img" alt="Obrázek" /*onerror="this.src='default-image.jpg';"*//>{course.name}</td>
                    <td>{day(course.dayOfWeek) + " " + course.startTime + " - " + course.endTime}</td>
                    <td className="even-spacing">
                      <button className="btn btn-secondary" data-toggle="modal" data-target="#infoModal1">Více info</button> 
                      <Link to={"/editCourse?courseId=" + course.id}><button className="btn btn-success" data-toggle="modal" onClick={selectCourse} style={{margin: "0vh 3px"}}>Upravit</button></Link>
                      <button className="btn btn-danger" data-toggle="modal" data-target="#deleteModal" onClick={selectCourse}>Smazat</button>
                    </td>
        </tr>  

        <div
        className="modal fade"
        id="infoModal1"
        tabIndex={-1}
        aria-labelledby="infoModalLabel1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header popup-header">
              <h2 className="modal-title" id="infoModalLabel1">
                {course.name}
              </h2>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body popup-content">
            <div className="popup-info">
                <p><strong>Učitel</strong><br/>David Bojko</p>
                <p><strong>Čas</strong><br/>{day(course.dayOfWeek) + " " + course.startTime + " - " + course.endTime}</p>
                <p><strong>Kapacita</strong><br/>{"Kapacita: " + course.signedInStudents?.length + "/" + course.capacity}</p>
                <p><strong>Popis</strong><br/>{course.description}</p>
            </div>
            <div className="popup-image">
                <img src={defaultUrl + course.image} alt={"Obrázek kroužku " + course.name}/>
            </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Zavřít
              </button>
            </div>
          </div>
        </div>
      </div>

        </>
     );
}

export default TeacherCourseCard;